var render = function render() {
  var _vm = this,
      _c = _vm._self._c;return _c('TableList', { ref: "relateList", staticStyle: { "width": "100%", "margin-bottom": "10px" }, attrs: { "border": "", "columnConfig": _vm.columnConfig, "list": _vm.list } });
};
var staticRenderFns = [];

export { render, staticRenderFns };